import React from "react";
import { IconProps } from "./types";

function IconEdit1(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4697 2.46997C17.8672 1.07251 20.1329 1.07251 21.5304 2.46997C22.9278 3.86744 22.9278 6.13317 21.5304 7.53063L8.32406 20.7369C8.30943 20.7515 8.29499 20.766 8.28072 20.7803C8.02876 21.0325 7.83033 21.2311 7.59577 21.3858C7.38892 21.5222 7.16458 21.63 6.92884 21.7063C6.66153 21.7929 6.38247 21.8237 6.02812 21.8629C6.00805 21.8651 5.98775 21.8674 5.9672 21.8697L2.58283 22.2457C2.35638 22.2709 2.13078 22.1917 1.96967 22.0306C1.80857 21.8695 1.72943 21.6439 1.75459 21.4175L2.13063 18.0331C2.13292 18.0125 2.13517 17.9922 2.13739 17.9722C2.17658 17.6178 2.20744 17.3388 2.29398 17.0715C2.37029 16.8357 2.47812 16.6114 2.61452 16.4045C2.76919 16.17 2.96782 15.9716 3.22002 15.7196C3.23431 15.7053 3.24877 15.6909 3.2634 15.6762L16.4697 2.46997ZM20.4697 3.53063C19.658 2.71896 18.342 2.71896 17.5304 3.53063L4.32406 16.7369C4.00864 17.0523 3.92696 17.139 3.86676 17.2303C3.80476 17.3243 3.75575 17.4263 3.72106 17.5335C3.68738 17.6375 3.67072 17.7554 3.62146 18.1988L3.34895 20.6514L5.80155 20.3789C6.2449 20.3296 6.36282 20.3129 6.46686 20.2792C6.57401 20.2446 6.67599 20.1955 6.77001 20.1335C6.8613 20.0733 6.94798 19.9917 7.2634 19.6762L20.4697 6.46997C21.2814 5.6583 21.2814 4.34231 20.4697 3.53063Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default IconEdit1;
